/*
This file is for handle DOM Element.
Author  : Dipjay Datta<dipjay.d@vcloudx.com>
Company : Vcloudx Infotech
Date	: 29/11/2017 07:14 PM
*/

/* global document */


/*
 * Class Stream represents a HTML DOM Element. It will handle the element properties
 */
const Element = (spec) => {
    const that = {};

    that.name = spec.name;
    that.src = spec.src;
    that.srcObject = spec.srcObject;
    that.href = spec.href;
    that.rel = spec.rel;
    that.type = spec.type;
    that.target = spec.target;
    that.autoplay = spec.autoplay;
    that.playsinline = spec.playsinline;
    that.alt = spec.alt;
    that.title = spec.title;
    that.id = spec.id;
    that.class = spec.class;
    that.style = Element.getStyle(spec.style);
    that.object = null;

    if (that.name && that.name != '' && that.name != null) {
        that.object = document.createElement(that.name);

        if (that.src && that.src != '' && that.src != null) {
            that.object.setAttribute('src', that.src);
        }
        if (that.srcObject && that.srcObject != '' && that.srcObject != null) {
            that.object.setAttribute('srcObject', that.srcObject);
        }
        if (that.href && that.href != '' && that.href != null) {
            that.object.setAttribute('href', that.href);
        }
        if (that.target && that.target != '' && that.target != null) {
            that.object.setAttribute('target', that.target);
        }
        if (that.alt && that.alt != '' && that.alt != null) {
            that.object.setAttribute('alt', that.alt);
        }
        if (that.title && that.title != '' && that.title != null) {
            that.object.setAttribute('title', that.title);
        }
        if (that.rel && that.rel != '' && that.rel != null) {
            that.object.setAttribute('rel', that.rel);
        }
        if (that.type && that.type != '' && that.type != null) {
            that.object.setAttribute('type', that.type);
        }
        if (that.autoplay && that.autoplay != '' && that.autoplay != null) {
            that.object.setAttribute('autoplay', that.autoplay);
        }
        if (that.playsinline && that.playsinline != '' && that.playsinline != null) {
            that.object.setAttribute('playsinline', that.playsinline);
        }
        if (that.id && that.id != '' && that.id != null) {
            that.object.setAttribute('id', that.id);
        }
        if (that.class && that.class != '' && that.class != null) {
            that.object.setAttribute('class', that.class);
        }
        if (that.style && that.style != '' && that.style != null) {
            that.object.setAttribute('style', that.style);
        }
    }
    return that.object;
};

Element.getStyle = (styles) => {
    let style = '';
    for (const key in styles) {
        style += `${key}:${styles[key]};`;
    }
    return style;
};

Element.getById = (id) => {
    const elem = document.getElementById(id);
    return elem;
};

Element.getByClass = (className) => {
    const elem = document.getElementsByClassName(className)[0];
    return elem;
};

Element.getByTag = (tagName) => {
    const elem = document.getElementsByTagName(tagName)[0];
    return elem;
};

Element.getTagByDOM = (tagName, DOM) => {
    const elem = DOM.getElementsByTagName(tagName)[0];
    return elem;
};

Element.getByClass = (className, DOM) => {
    const elem = DOM.getElementsByClassName(className)[0];
    return elem;
};

Element.append = (childDOM, parentDOM) => {
    const elem = parentDOM.appendChild(childDOM);
    return elem;
};

Element.setStyle = (DOM, property, value) => {
    DOM.style[property] = value;
};

Element.addCssFile = (DOM) => {
    Element.getByTag('head').appendChild(DOM);
};

Element.checkParam = (elem) => {
    let ret = false;
    if (elem && (elem != null) && (elem != '')) { ret = true; }
    return ret;
};

export default Element;



//////////////////
// WEBPACK FOOTER
// ./src/views/Element.js
// module id = 3
// module chunks = 0